// extracted by mini-css-extract-plugin
export default {"scottSecretSantaApp":"RulesBody_scottSecretSantaApp__qSvak","rulesBody":"RulesBody_rulesBody__sEg56"};